module.exports = __webpack_public_path__ + "2a64789056a4dd98537d3c707aef725b.svg";